import { Seo } from '../components/Seo';
import { LEGAL_PAGES } from '../lib/config';

const page = LEGAL_PAGES.find((p) => p.path === '/terms')!;

export function TermsPage() {
  return (
    <>
      <Seo page={page} />
      <section className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-extrabold text-text-primary sm:text-4xl">{page.h1}</h1>
        <p className="mt-2 text-sm text-text-secondary">Effective Date: July 26, 2026</p>

        <div className="prose prose-invert mt-8 max-w-none">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using Image Enlarger, you agree to be bound by these Terms of Service. If
            you do not agree, please do not use the Service.
          </p>

          <h2>2. Description of Service</h2>
          <p>
            Image Enlarger is an online AI-powered image upscaling and enlargement tool. The Service
            is provided for lawful purposes only.
          </p>

          <h2>3. User Responsibilities</h2>
          <p>You agree to use the Service only for images you have the right to upload, modify, and distribute. You may not use the Service to process unlawful, infringing, abusive, or harmful content.</p>

          <h2>4. Intellectual Property</h2>
          <p>
            You retain ownership of images you upload. We do not claim ownership of your content. We
            do not use uploaded images to train AI models.
          </p>

          <h2>5. Free and Paid Plans</h2>
          <p>
            The free plan allows 2 image upscales per day. Pro plans include 100 images per month and
            additional features as described on the Pricing page. Payments in the first version are
            processed through placeholder checkout flows.
          </p>

          <h2>6. Refunds</h2>
          <p>
            Refunds are handled on a case-by-case basis. Please contact support@imageenlarger.co
            with refund requests.
          </p>

          <h2>7. Disclaimers</h2>
          <p>
            The Service is provided "as is" without warranties of any kind. AI upscaling results
            vary by image and may not meet every expectation. We are not liable for indirect,
            incidental, or consequential damages arising from use of the Service.
          </p>

          <h2>8. Termination</h2>
          <p>
            We may suspend or terminate access to the Service for users who violate these terms or
            abuse usage limits.
          </p>

          <h2>9. Governing Law</h2>
          <p>These Terms are governed by the laws of the State of Delaware, United States.</p>

          <h2>10. Contact</h2>
          <p>
            For questions about these Terms, email{' '}
            <a href="mailto:support@imageenlarger.co">support@imageenlarger.co</a>.
          </p>
        </div>
      </section>
    </>
  );
}
